
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/purchase-pass",
      function () {
        return require("private-next-pages/world/purchase-pass.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/purchase-pass"])
      });
    }
  